module.exports = __webpack_public_path__ + "img/lugares3.b92d0bd6.jpg";